import {
  FETCH_INVENTORIES,
  FETCH_INVENTORIED_ITEMS,
  FETCH_INVENTORIED_ITEMS_CSV,
  FETCH_SHIPMENT_REPORT,
  FETCH_INVOICE_REPORT,
  FETCH_INVOICE_REPORT_CSV,
  FETCH_PRODUCTION_REPORT,
  FETCH_INVENTORY_WASTE_REPORT,
  FETCH_INVENTORY_WASTE_REPORT_CSV,
  FETCH_YIELD_REPORT,
  FETCH_YIELD_REPORT_CSV,
  FETCH_AVERAGE_YIELD,
  FETCH_EXPIRED_INVENTORIES_REPORT,
  FETCH_EXPIRED_INVENTORIES_REPORT_CSV,
  FETCH_WEIGHTED_PRICE_REPORT,
  FETCH_WEIGHTED_PRICE_REPORT_CSV,
  FETCH_RECEIVING_REPORT,
} from "./types";
import * as API from "./api";

// --------------------------------------------------------------------------
// FETCH_INVENTORIES
// --------------------------------------------------------------------------
export const fetchInventories = (page, active, item, station, brand, is_ingredient, from, plant, lot, location, grade) => ({
  type: FETCH_INVENTORIES.init,
  payload: API.fetchInventories(page, active, item, station, brand, is_ingredient, from, plant, lot, location, grade),
});

export const fetchInventoriesSuccess = (info) => ({
  type: FETCH_INVENTORIES.success,
  payload: info,
});

export const fetchInventoriesFailure = (error) => ({
  type: FETCH_INVENTORIES.failure,
  payload: error,
});

// --------------------------------------------------------------------------
// FETCH_INVENTORIED_ITEMS
// --------------------------------------------------------------------------
export const fetchInventoriedItems = (page, search, plant, lot, station) => ({
  type: FETCH_INVENTORIED_ITEMS.init,
  payload: API.fetchInventoriedItems(page, search, plant, lot, station),
});

export const fetchInventoriedItemsSuccess = (info) => ({
  type: FETCH_INVENTORIED_ITEMS.success,
  payload: info,
});

export const fetchInventoriedItemsFailure = (error) => ({
  type: FETCH_INVENTORIED_ITEMS.failure,
  payload: error,
});

// --------------------------------------------------------------------------
// FETCH_INVENTORIED_ITEMS_CSV
// --------------------------------------------------------------------------
export const fetchInventoriedItemsCSV = (search, plant, lot, station) => ({
  type: FETCH_INVENTORIED_ITEMS_CSV.init,
  payload: API.fetchInventoriedItemsCSV(search, plant, lot, station),
});

export const fetchInventoriedItemsCSVSuccess = (info) => ({
  type: FETCH_INVENTORIED_ITEMS_CSV.success,
  payload: info,
});

export const fetchInventoriedItemsCSVFailure = (error) => ({
  type: FETCH_INVENTORIED_ITEMS_CSV.failure,
  payload: error,
});

// --------------------------------------------------------------------------
// FETCH_SHIPMENT_REPORT
// --------------------------------------------------------------------------
export const fetchShipmentReport = (page, from, to, search, customer, plant, lot, shipment_id) => ({
  type: FETCH_SHIPMENT_REPORT.init,
  payload: API.fetchShipmentReport(page, from, to, search, customer, plant, lot, shipment_id),
});

export const fetchShipmentReportSuccess = (data) => ({
  type: FETCH_SHIPMENT_REPORT.success,
  payload: data,
});

export const fetchShipmentReportFailure = (error) => ({
  type: FETCH_SHIPMENT_REPORT.failure,
  payload: error,
});

// --------------------------------------------------------------------------
// FETCH_INVOICE_REPORT
// --------------------------------------------------------------------------
export const fetchInvoiceReport = (page, from, to, search) => ({
  type: FETCH_INVOICE_REPORT.init,
  payload: API.fetchInvoiceReport(page, from, to, search),
});

export const fetchInvoiceReportSuccess = (data) => ({
  type: FETCH_INVOICE_REPORT.success,
  payload: data,
});

export const fetchInvoiceReportFailure = (error) => ({
  type: FETCH_INVOICE_REPORT.failure,
  payload: error,
});

// --------------------------------------------------------------------------
// FETCH_INVOICE_REPORT_CSV
// --------------------------------------------------------------------------
export const fetchInvoiceReportCSV = (from, to) => ({
  type: FETCH_INVOICE_REPORT_CSV.init,
  payload: API.fetchInvoiceReportCSV(from, to),
});

export const fetchInvoiceReportCSVSuccess = (data) => ({
  type: FETCH_INVOICE_REPORT_CSV.success,
  payload: data,
});

export const fetchInvoiceReportCSVFailure = (error) => ({
  type: FETCH_INVOICE_REPORT_CSV.failure,
  payload: error,
});

// --------------------------------------------------------------------------
// FETCH_PRODUCTION_REPORT
// --------------------------------------------------------------------------
export const fetchProductionReport = (page, search, from, to, station, parent_Child, plant, lot) => ({
  type: FETCH_PRODUCTION_REPORT.init,
  payload: API.fetchProductionReport(page, search, from, to, station, parent_Child, plant, lot),
});

export const fetchProductionReportSuccess = (data) => ({
  type: FETCH_PRODUCTION_REPORT.success,
  payload: data,
});

export const fetchProductionReportFailure = (error) => ({
  type: FETCH_PRODUCTION_REPORT.failure,
  payload: error,
});

// --------------------------------------------------------------------------
// FETCH_INVENTORY_WASTE_REPORT
// --------------------------------------------------------------------------
export const fetchInventoryWasteReport = (page, search, from, to, category, plant, lot) => ({
  type: FETCH_INVENTORY_WASTE_REPORT.init,
  payload: API.fetchInventoryWasteReport(page, search, from, to, category, plant, lot),
});

export const fetchInventoryWasteReportSuccess = (info) => ({
  type: FETCH_INVENTORY_WASTE_REPORT.success,
  payload: info,
});

export const fetchInventoryWasteReportFailure = (error) => ({
  type: FETCH_INVENTORY_WASTE_REPORT.failure,
  payload: error,
});

// --------------------------------------------------------------------------
// FETCH_INVENTORY_WASTE_REPORT_CSV
// --------------------------------------------------------------------------
export const fetchInventoryWasteReportCSV = (search, from, to, category, plant, lot) => ({
  type: FETCH_INVENTORY_WASTE_REPORT_CSV.init,
  payload: API.fetchInventoryWasteReportCSV(search, from, to, category, plant, lot),
});

export const fetchInventoryWasteReportCSVSuccess = (data) => ({
  type: FETCH_INVENTORY_WASTE_REPORT_CSV.success,
  payload: data,
});

export const fetchInventoryWasteReportCSVFailure = (error) => ({
  type: FETCH_INVENTORY_WASTE_REPORT_CSV.failure,
  payload: error,
});

// --------------------------------------------------------------------------
// FETCH_YIELD_REPORT
// --------------------------------------------------------------------------
export const fetchYieldReport = (page, search, from, to, station) => ({
  type: FETCH_YIELD_REPORT.init,
  payload: API.fetchYieldReport(page, search, from, to, station),
});

export const fetchYieldReportSuccess = (info) => ({
  type: FETCH_YIELD_REPORT.success,
  payload: info,
});

export const fetchYieldReportFailure = (error) => ({
  type: FETCH_YIELD_REPORT.failure,
  payload: error,
});

// --------------------------------------------------------------------------
// FETCH_YIELD_REPORT_CSV
// --------------------------------------------------------------------------
export const fetchYieldReportCSV = (search, from, to, station) => ({
  type: FETCH_YIELD_REPORT_CSV.init,
  payload: API.fetchYieldReportCSV(search, from, to, station),
});

export const fetchYieldReportCSVSuccess = (data) => ({
  type: FETCH_YIELD_REPORT_CSV.success,
  payload: data,
});

export const fetchYieldReportCSVFailure = (error) => ({
  type: FETCH_YIELD_REPORT_CSV.failure,
  payload: error,
});

// --------------------------------------------------------------------------
// FETCH_AVERAGE_YIELD
// --------------------------------------------------------------------------
export const fetchAverageYield = (id, fromDate, toDate) => ({
  type: FETCH_AVERAGE_YIELD.init,
  payload: API.fetchAverageYield(id, fromDate, toDate),
});

export const fetchAverageYieldSuccess = (data) => ({
  type: FETCH_AVERAGE_YIELD.success,
  payload: data,
});

export const fetchAverageYieldFailure = (error) => ({
  type: FETCH_AVERAGE_YIELD.failure,
  payload: error,
});

// --------------------------------------------------------------------------
// FETCH_EXPIRED_INVENTORIES_REPORT
// --------------------------------------------------------------------------
export const fetchExpiredInventoriesReport = (page, search, from, to, location, plant, lot) => ({
  type: FETCH_EXPIRED_INVENTORIES_REPORT.init,
  payload: API.fetchExpiredInventoriesReport(page, search, from, to, location, plant, lot),
});

export const fetchExpiredInventoriesReportSuccess = (info) => ({
  type: FETCH_EXPIRED_INVENTORIES_REPORT.success,
  payload: info,
});

export const fetchExpiredInventoriesReportFailure = (error) => ({
  type: FETCH_EXPIRED_INVENTORIES_REPORT.failure,
  payload: error,
});

// --------------------------------------------------------------------------
// FETCH_AVERAGE_YIELD
// --------------------------------------------------------------------------
export const fetchExpiredInventoriesReportCSV = (search, from, to, location, plant, lot) => ({
  type: FETCH_EXPIRED_INVENTORIES_REPORT_CSV.init,
  payload: API.fetchExpiredInventoriesReportCSV(search, from, to, location, plant, lot),
});

export const fetchExpiredInventoriesReportCSVSuccess = (data) => ({
  type: FETCH_EXPIRED_INVENTORIES_REPORT_CSV.success,
  payload: data,
});

export const fetchExpiredInventoriesReportCSVFailure = (error) => ({
  type: FETCH_EXPIRED_INVENTORIES_REPORT_CSV.failure,
  payload: error,
});

// --------------------------------------------------------------------------
// FETCH_WEIGHTED_PRICE_REPORT
// --------------------------------------------------------------------------
export const fetchWeightedPriceReport = (page, plant, lot) => ({
  type: FETCH_WEIGHTED_PRICE_REPORT.init,
  payload: API.fetchWeightedPriceReport(page, plant, lot),
});

export const fetchWeightedPriceReportSuccess = (info) => ({
  type: FETCH_WEIGHTED_PRICE_REPORT.success,
  payload: info,
});

export const fetchWeightedPriceReportFailure = (error) => ({
  type: FETCH_WEIGHTED_PRICE_REPORT.failure,
  payload: error,
});

// --------------------------------------------------------------------------
// FETCH_WEIGHTED_PRICE_REPORT_CSV
// --------------------------------------------------------------------------
export const fetchWeightedPriceReportCSV = (plant, lot) => ({
  type: FETCH_WEIGHTED_PRICE_REPORT_CSV.init,
  payload: API.fetchWeightedPriceReportCSV(plant, lot),
});

export const fetchWeightedPriceReportCSVSuccess = (data) => ({
  type: FETCH_WEIGHTED_PRICE_REPORT_CSV.success,
  payload: data,
});

export const fetchWeightedPriceReportCSVFailure = (error) => ({
  type: FETCH_WEIGHTED_PRICE_REPORT_CSV.failure,
  payload: error,
});

// --------------------------------------------------------------------------
// FETCH_RECEIVING_REPORT
// --------------------------------------------------------------------------
export const fetchReceivingReport = (page, date, vendor_id, lot) => ({
  type: FETCH_RECEIVING_REPORT.init,
  payload: API.fetchReceivingReport(page, date, vendor_id, lot),
});

export const fetchReceivingReportSuccess = (info) => ({
  type: FETCH_RECEIVING_REPORT.success,
  payload: info,
});

export const fetchReceivingReportFailure = (error) => ({
  type: FETCH_RECEIVING_REPORT.failure,
  payload: error,
});
